module.exports = __webpack_public_path__ + "img/Ident-Process-8-mobile.665dd2d6.png";